import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-management-stra-page',
  templateUrl: './management-stra-page.component.html',
  styleUrls: ['./management-stra-page.component.css'],
})
export class ManagementStraPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.managementStratgeySave;
  private getApi = environment.url + environment.managementStratgeyGet;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.settingsForm = this.fb.group({
      // "username": ['', [Validators.required]],
      // question 001
      missionVisionIncCentre: [''],
      missionVisionUrlIcWebsite: [''],
      missionVisionDocuments: new FormArray([]),
      missionVisionImagefile: [''],
      missionVisionStatus: [0],
      // question 002
      standardoperatingIncCentre: [''],
      // "standardoperatingUrlIcWebsite": [''],
      standardoperatingdocuments: new FormArray([]),
      standardoperatingImagefile: [''],
      standardoperatingStatus: [0],
      // question 003
      shortMidLongIncCentre: [''],
      shortMidLongdocuments: new FormArray([]),
      shortMidLongImagefile: [''],
      shortMidLongStatus: [0],
      // question 004
      projectmanagementcommitteeIncCentre: [''],
      projectmanagementcommitteeUrlIcWebsite: [''],
      projectmanagementcommitteedocuments: new FormArray([]),
      projectmanagementcommitteeImagefile: [''],
      projectmanagementcommitteeStatus: [0],
      // question 005
      boardmeetingsIncCentre: [''],
      // "boardmeetingMinutes": new FormArray([]),
      // "boardMeetingsConductedCount": [''],
      boardmeetingsdocuments: new FormArray([]),
      boardmeetingsImagefile: [''],
      boardmeetingsStatus: [0],
      // question 006
      quaterlyreviewIncCentre: [''],
      quaterlyreviewdocuments: new FormArray([]),
      quaterlyreviewImagefile: [''],
      quaterlyreviewStatus: [0],
      // question 007
      enterpriceresourceplanCentre: [''],
      enterpriceresourceplandocuments: new FormArray([]),
      enterpriceresourceplanImagefile: [''],
      enterpriceresourceplanStatus: [0],
      // question 008
      rolemanangementteamCentre: [''],
      rolemanangementteamdocuments: new FormArray([]),
      rolemanangementteamImagefile: [''],
      rolemanangementteamStatus: [0],
    });
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();

    // if(this.mobileQuery.matches==true){
    //   this.isMenu = true
    // }
  }
  get setting() {
    return this.settingsForm.controls;
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngOnInit(): void {
    // var getform = this.settingsForm.value
    // getform.username = sessionStorage.getItem('username')
    // this.settingsForm.patchValue(getform)
    this.getPush();
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.responseStatus != 'Failed') {
          this.settingsForm.patchValue(data);

          if (data.missionVisionIncCentre == 'Yes') {
            this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
          }
          if (data.standardoperatingIncCentre == 'Yes') {
            this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
          }
          if (data.shortMidLongIncCentre == 'Yes') {
            this.showOptionsthree('Yes', '.upload2', 2, '.set-succ2');
          }
          if (data.projectmanagementcommitteeIncCentre == 'Yes') {
            this.showOptionsfour('Yes', '.upload3', 3, '.set-succ3');
          }
          if (data.boardmeetingsIncCentre == 'Yes') {
            this.showOptionsfive('Yes', '.upload4', 4, '.set-succ4');
          }
          if (data.quaterlyreviewIncCentre == 'Yes') {
            this.showOptionssix('Yes', '.upload5', 5, '.set-succ5');
          }
          if (data.enterpriceresourceplanCentre == 'Yes') {
            this.showOptionsseven('Yes', '.upload6', 6, '.set-succ6');
          }
          if (data.rolemanangementteamCentre == 'Yes') {
            this.showOptions8('Yes', '.upload7', 7, '.set-succ7');
          }
          var getform = this.settingsForm.value;
          if (
            data.missionVisionDocuments != '' &&
            data.missionVisionDocuments != undefined
          ) {
            this.documentValues[0] = data.missionVisionDocuments;
            getform.missionVisionImagefile =
              data.missionVisionDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ0').addClass('success');
              $('.upload-wrapper.upload0').addClass('d-none');
              $('.upload-wrapper.upload0').removeClass('success');
              $('.remove-wrapper.upload0').addClass('d-flex');
              $('.remove-wrapper.upload0').addClass('active');
            }, 5000);
          }
          if (
            data.standardoperatingdocuments != '' &&
            data.standardoperatingdocuments != undefined
          ) {
            this.documentValues[1] = data.standardoperatingdocuments;
            getform.standardoperatingImagefile =
              data.standardoperatingdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ1').addClass('success');
              $('.upload-wrapper.upload1').addClass('d-none');
              $('.upload-wrapper.upload1').removeClass('success');
              $('.remove-wrapper.upload1').addClass('d-flex');
              $('.remove-wrapper.upload1').addClass('active');
            }, 5000);
          }
          if (
            data.shortMidLongdocuments != '' &&
            data.shortMidLongdocuments != undefined
          ) {
            this.documentValues[2] = data.shortMidLongdocuments;
            getform.shortMidLongImagefile =
              data.shortMidLongdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ2').addClass('success');
              $('.upload-wrapper.upload2').addClass('d-none');
              $('.upload-wrapper.upload2').removeClass('success');
              $('.remove-wrapper.upload2').addClass('d-flex');
              $('.remove-wrapper.upload2').addClass('active');
            }, 5000);
          }
          if (
            data.projectmanagementcommitteedocuments != '' &&
            data.projectmanagementcommitteedocuments != undefined
          ) {
            this.documentValues[3] = data.projectmanagementcommitteedocuments;
            getform.projectmanagementcommitteeImagefile =
              data.projectmanagementcommitteedocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ3').addClass('success');
              $('.upload-wrapper.upload3').addClass('d-none');
              $('.upload-wrapper.upload3').removeClass('success');
              $('.remove-wrapper.upload3').addClass('d-flex');
              $('.remove-wrapper.upload3').addClass('active');
            }, 5000);
          }
          if (
            data.boardmeetingsdocuments != '' &&
            data.boardmeetingsdocuments != undefined
          ) {
            this.documentValues[4] = data.boardmeetingsdocuments;
            getform.boardmeetingsImagefile =
              data.boardmeetingsdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ4').addClass('success');
              $('.upload-wrapper.upload4').addClass('d-none');
              $('.upload-wrapper.upload4').removeClass('success');
              $('.remove-wrapper.upload4').addClass('d-flex');
              $('.remove-wrapper.upload4').addClass('active');
            }, 5000);
          }
          if (
            data.quaterlyreviewdocuments != '' &&
            data.quaterlyreviewdocuments != undefined
          ) {
            this.documentValues[5] = data.quaterlyreviewdocuments;
            getform.quaterlyreviewImagefile =
              data.quaterlyreviewdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ5').addClass('success');
              $('.upload-wrapper.upload5').addClass('d-none');
              $('.upload-wrapper.upload5').removeClass('success');
              $('.remove-wrapper.upload5').addClass('d-flex');
              $('.remove-wrapper.upload5').addClass('active');
            }, 5000);
          }
          if (
            data.enterpriceresourceplandocuments != '' &&
            data.enterpriceresourceplandocuments != undefined
          ) {
            this.documentValues[6] = data.enterpriceresourceplandocuments;
            getform.enterpriceresourceplanImagefile =
              data.enterpriceresourceplandocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ6').addClass('success');
              $('.upload-wrapper.upload6').addClass('d-none');
              $('.upload-wrapper.upload6').removeClass('success');
              $('.remove-wrapper.upload6').addClass('d-flex');
              $('.remove-wrapper.upload6').addClass('active');
            }, 5000);
          }
          if (
            data.rolemanangementteamdocuments != '' &&
            data.rolemanangementteamdocuments != undefined
          ) {
            this.documentValues[7] = data.rolemanangementteamdocuments;
            getform.rolemanangementteamImagefile =
              data.rolemanangementteamdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ7').addClass('success');
              $('.upload-wrapper.upload7').addClass('d-none');
              $('.upload-wrapper.upload7').removeClass('success');
              $('.remove-wrapper.upload7').addClass('d-flex');
              $('.remove-wrapper.upload7').addClass('active');
            }, 5000);
          }
          this.settingsForm.patchValue(getform);
          // this.getdata.amizhthLoader('hide')
        }
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  viewReasonBtn(status) {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  getPush() {
    for (let i = 0; i < 8; i++) {
      var req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      this.documentValues.push(req);
    }
  }
  setStatus(event, key, value) {
    this.settingsForm.controls[key].setValue(value);
  }
  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  fileUpload(event, val, i, set) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      var reader = new FileReader();
      var imagetype = this.selecetdFile.type;
      var imagedatatype = imagetype.split('/');
      var img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          var splType = this.selecetdFile.type.split('/');
          this.url = reader.result;
          var spl = this.url.split(',');
          var val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;
          if (i == 0) {
            this.settingsForm.controls['missionVisionStatus'].setValue(7);
            this.settingsForm.controls['missionVisionImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 1) {
            this.settingsForm.controls['standardoperatingStatus'].setValue(7);
            this.settingsForm.controls['standardoperatingImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 2) {
            this.settingsForm.controls['shortMidLongStatus'].setValue(7);
            this.settingsForm.controls['shortMidLongImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 3) {
            this.settingsForm.controls[
              'projectmanagementcommitteeStatus'
            ].setValue(7);
            this.settingsForm.controls[
              'projectmanagementcommitteeImagefile'
            ].setValue(this.selecetdFile.name);
          }
          if (i == 4) {
            this.settingsForm.controls['boardmeetingsStatus'].setValue(7);
            this.settingsForm.controls['boardmeetingsImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 5) {
            this.settingsForm.controls['quaterlyreviewStatus'].setValue(7);
            this.settingsForm.controls['quaterlyreviewImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 6) {
            this.settingsForm.controls['enterpriceresourceplanStatus'].setValue(
              7
            );
            this.settingsForm.controls[
              'enterpriceresourceplanImagefile'
            ].setValue(this.selecetdFile.name);
          }
          if (i == 7) {
            this.settingsForm.controls['rolemanangementteamStatus'].setValue(7);
            this.settingsForm.controls['rolemanangementteamImagefile'].setValue(
              this.selecetdFile.name
            );
          }
        };
        setTimeout(function () {
          var datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);
        setTimeout(function () {
          var datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded');
          $(datas).addClass('success');
          $(set).addClass('success');
        }, 1600);
        setTimeout(function () {
          var datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none');
          $(datas).removeClass('success');
          var data = '.remove-wrapper' + val;
          $(data).addClass('d-flex');
          $(data).addClass('active');
        }, 5000);
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  removeFile(val, i, set) {
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';
    setTimeout(function () {
      var datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');
      var data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');
      $(set).removeClass('success');
    }, 1000);
    if (i == 0) {
      this.settingsForm.controls['missionVisionImagefile'].setValue('');
    }
    if (i == 1) {
      this.settingsForm.controls['standardoperatingImagefile'].setValue('');
    }
    if (i == 2) {
      this.settingsForm.controls['shortMidLongImagefile'].setValue('');
    }
    if (i == 3) {
      this.settingsForm.controls[
        'projectmanagementcommitteeImagefile'
      ].setValue('');
    }
    if (i == 4) {
      this.settingsForm.controls['boardmeetingsImagefile'].setValue('');
    }
    if (i == 5) {
      this.settingsForm.controls['quaterlyreviewImagefile'].setValue('');
    }
    if (i == 6) {
      this.settingsForm.controls['enterpriceresourceplanImagefile'].setValue(
        ''
      );
    }
    if (i == 7) {
      this.settingsForm.controls['rolemanangementteamImagefile'].setValue('');
    }
  }
  Optionsonechecked;
  showOptionsone(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['missionVisionStatus'].setValue(1);
      this.settingsForm.controls['missionVisionUrlIcWebsite'].setValue('');
      this.settingsForm.controls['missionVisionImagefile'].setValue('');
      this.settingsForm.controls['missionVisionUrlIcWebsite'].clearValidators();
      this.settingsForm.controls['missionVisionImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['missionVisionUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['missionVisionImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'missionVisionUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'missionVisionImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked;
  showOptionstwo(event, val, i, set) {
    this.Optionstwochecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['standardoperatingStatus'].setValue(1);
      // this.settingsForm.controls['standardoperatingUrlIcWebsite'].setValue('');
      this.settingsForm.controls['standardoperatingImagefile'].setValue('');
      // this.settingsForm.controls['standardoperatingUrlIcWebsite'].clearValidators();
      this.settingsForm.controls[
        'standardoperatingImagefile'
      ].clearValidators();
    } else {
      // this.settingsForm.controls['standardoperatingUrlIcWebsite'].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['standardoperatingImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // this.settingsForm.controls['standardoperatingUrlIcWebsite'].updateValueAndValidity();
    this.settingsForm.controls[
      'standardoperatingImagefile'
    ].updateValueAndValidity();
  }
  Optionsthreechecked;
  showOptionsthree(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['shortMidLongStatus'].setValue(1);
      this.settingsForm.controls['shortMidLongImagefile'].setValue('');
      this.settingsForm.controls['shortMidLongImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['shortMidLongImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'shortMidLongImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked;
  showOptionsfour(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['projectmanagementcommitteeStatus'].setValue(
        1
      );
      this.settingsForm.controls[
        'projectmanagementcommitteeUrlIcWebsite'
      ].setValue('');
      this.settingsForm.controls[
        'projectmanagementcommitteeImagefile'
      ].setValue('');
      this.settingsForm.controls[
        'projectmanagementcommitteeUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'projectmanagementcommitteeImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'projectmanagementcommitteeUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls[
        'projectmanagementcommitteeImagefile'
      ].setValidators([Validators.required]);
    }
    this.settingsForm.controls[
      'projectmanagementcommitteeUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'projectmanagementcommitteeImagefile'
    ].updateValueAndValidity();
  }
  Optionsfivechecked;
  showOptionsfive(event, val, i, set) {
    this.Optionsfivechecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['boardmeetingsStatus'].setValue(1);
      // this.settingsForm.controls['boardmeetingsUrlIcWebsite'].setValue('');
      this.settingsForm.controls['boardmeetingsImagefile'].setValue('');
      // this.settingsForm.controls['boardmeetingsUrlIcWebsite'].clearValidators();
      this.settingsForm.controls['boardmeetingsImagefile'].clearValidators();
    } else {
      // this.settingsForm.controls['boardmeetingsUrlIcWebsite'].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['boardmeetingsImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // this.settingsForm.controls['boardmeetingsUrlIcWebsite'].updateValueAndValidity();
    this.settingsForm.controls[
      'boardmeetingsImagefile'
    ].updateValueAndValidity();
  }
  Optionssixchecked;
  showOptionssix(event, val, i, set) {
    this.Optionssixchecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['quaterlyreviewStatus'].setValue(1);
      // this.settingsForm.controls['quaterlyreviewConductedCount'].setValue(0);
      this.settingsForm.controls['quaterlyreviewImagefile'].setValue('');
      // this.settingsForm.controls['quaterlyreviewConductedCount'].clearValidators();
      this.settingsForm.controls['quaterlyreviewImagefile'].clearValidators();
    } else {
      // this.settingsForm.controls['quaterlyreviewConductedCount'].setValidators([Validators.required]);
      this.settingsForm.controls['quaterlyreviewImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // this.settingsForm.controls['quaterlyreviewConductedCount'].updateValueAndValidity();
    this.settingsForm.controls[
      'quaterlyreviewImagefile'
    ].updateValueAndValidity();
  }
  // setTable(event) {
  //   if (event == 'Yes') {
  //     for (let i = 0; i < 3; i++) {
  //       this.minutesList.push(this.fb.group({
  //         minutes: ['', [Validators.required]],
  //       }))
  //     }
  //   } else {
  //     while (this.minutesList.length) {
  //       this.minutesList.removeAt(0);
  //     }
  //   }
  // }
  // setUpdate(event, i, set) {
  //   var data = event.target.value
  //   this.minutesList.value[i]
  //   if (data != '') {
  //     if (this.minutesList.value[i].minutes != '') {
  //       $(set).addClass("success");
  //     } else {
  //       $(set).removeClass("success");
  //     }
  //   } else {
  //     $(set).removeClass("success");
  //   }
  // }
  newDynamic;
  // addRow(i) {
  //   this.minutesList.value
  //   if (this.minutesList.controls[i].status == 'VALID') {
  //     this.minutesList.push(this.fb.group({
  //       minutes: ['', [Validators.required]],
  //     }))
  //   }
  // }
  // deleteRow(i, set) {
  //   if (this.minutesList.length > 1) {
  //     this.minutesList.controls.splice(i, 1);
  //   } else {
  //     this.minutesList.controls.splice(i, 1);
  //     this.minutesList.push(this.fb.group({
  //       minutes: ['', [Validators.required]],
  //     }))
  //     $(set).removeClass("success");
  //   }
  // }
  Optionssevenchecked;
  showOptionsseven(event, val, i, set) {
    this.Optionssevenchecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['enterpriceresourceplanStatus'].setValue(1);
      this.settingsForm.controls['enterpriceresourceplanImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'enterpriceresourceplanImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'enterpriceresourceplanImagefile'
      ].setValidators([Validators.required]);
    }
    this.settingsForm.controls[
      'enterpriceresourceplanImagefile'
    ].updateValueAndValidity();
  }
  Options8checked;
  showOptions8(event, val, i, set) {
    this.Options8checked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['rolemanangementteamStatus'].setValue(1);
      this.settingsForm.controls['rolemanangementteamImagefile'].setValue('');
      this.settingsForm.controls[
        'rolemanangementteamImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls['rolemanangementteamImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'rolemanangementteamImagefile'
    ].updateValueAndValidity();
  }
  saveBtn() {
    var getform = this.settingsForm.value;

    if (this.settingsForm.invalid) {
      console.log(this.settingsForm);

      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      if (this.documentValues[0][0].documentFile != '') {
        getform.missionVisionDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.standardoperatingdocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.shortMidLongdocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.projectmanagementcommitteedocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.boardmeetingsdocuments = this.documentValues[4];
      }
      if (this.documentValues[5][0].documentFile != '') {
        getform.quaterlyreviewdocuments = this.documentValues[5];
      }
      if (this.documentValues[6][0].documentFile != '') {
        getform.enterpriceresourceplandocuments = this.documentValues[6];
      }
      if (this.documentValues[7][0].documentFile != '') {
        getform.rolemanangementteamdocuments = this.documentValues[7];
      }
      this.getdata.amizhthLoader('show');

      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.step++;
          this.notify.notifysuccess(data.responseMessage);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[0].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
